<template>
  <div style="padding: 10px;">
    <div class="col-md-12">
      <div class="col-md-12 cards-default" v-if="listaLogID != null" style="background-color:#fff;border-radius:5px;" >
          <!--{{listaLogID}} <br>-->
            <div  style="line-height: 32px; margin-top:20px; margin-bottom:20px; padding-top:15px;font-size: 26px;" >
                <h2 style="text-align: center;">Historico de Movimentações</h2>
                <h3 style="padding-left: 20px;font-size: 20px;text-align: center;">Manifestação Número: {{ listaLogID[0].uuid }}</h3>
            </div>
            <div class="cards-list row" style='padding-left: 18px;'>
              <div class="card card-col" v-for="i in listaLogID" :key="i.id">
                <div class="content">
                    <div class="calendar-sm">
                        <div class="month cor1" v-if="i.mes == '01'">Jan</div>
                        <div class="month cor2" v-if="i.mes == '02'">Fev</div>
                        <div class="month cor3" v-if="i.mes == '03'">Mar</div>
                        <div class="month cor4" v-if="i.mes == '04'">Abr</div>
                        <div class="month cor5" v-if="i.mes == '05'">Mai</div>
                        <div class="month cor6" v-if="i.mes == '06'">Jun</div>
                        <div class="month cor7" v-if="i.mes == '07'">Jul</div>
                        <div class="month cor8" v-if="i.mes == '08'">Ago</div>
                        <div class="month cor9" v-if="i.mes == '09'">Set</div>
                        <div class="month cor10" v-if="i.mes == '10'">Out</div>
                        <div class="month cor11" v-if="i.mes == '11'">Nov</div>
                        <div class="month cor12" v-if="i.mes == '12'">Dez</div>
                        <div class="heading day" >{{i.dia}}</div>
                        <div class="day-abbr" >{{i.ano}}</div>
                    </div>
                    <div class="content-info">
                        <h4 class="title heading h-4">Usuario: {{i.usuario_sistema}}</h4>
                        <hr>
                        <h5 class="title heading h-4">
                          Departamento antigo: <br>
                           <p style='color: rgb(3, 58, 234);'>{{i.secretaria_old}}</p>
                        </h5>
                        <h5 class="title heading h-4">
                          Departamento novo: <br>
                          <p style='color: rgb(3, 58, 234);'>{{i.secretaria_new}}</p>
                        </h5>
                        <!--<h6 class="title heading h-4" style='color: #033aea;'>
                          {{i.horario}} - {{i.data}} - IP: {{i.ip}} 
                        </h6>-->
                    </div>
                </div>
                <div style="width:100%;background-color: #ebeef1;padding: 20px;"> 
                  <h6 data-v-ef56796a="" class="title heading h-4" style="color: rgb(23 24 29);">
                      {{i.horario}} - {{i.data}} - IP: {{i.ip}} 
                  </h6>
                </div>  
              </div>
            </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-10">
          <h4>Log de Manifestações Movimentadas</h4>
        </div>
      </div>
    </div>
    
    <div class="col-md-12">
      <vue-good-table
        :columns="columns"
        :rows="log"
        :lineNumbers="false"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            mode: 'pages',
            perPage: 10,
            position: 'bottom',
            perPageDropdown: [5, 10, 15, 25],
            dropdownAllowAll: false,
            nextLabel: 'Próximo',
            prevLabel: 'Anterior',
            rowsPerPageLabel: 'Linhas por página',
            ofLabel: 'de',
            pageLabel: 'pagina', 
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field == 'uuid'">
            <h5 @click="exibir(props.row)" class='item-log' data-toggle="tooltip" title="Clique aqui e veja o Historico!">{{props.row.uuid}}</h5>
          </div>

        </template>
      </vue-good-table>
    </div>
    
    
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/logController.js";
import "src/controller/sistema/usuarioController.js";
import "src/controller/sistema/assuntoSecretariaController.js";
import SwitchButton from "src/components/switch.vue";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
    SwitchButton,
  },
  data() {
    return {
      columns: [
        {
          label: "ID da Manifestacao",
          field: "uuid",
        },
        {
          label: "Usuario que Alterou",
          field: "usuario_sistema",
        },
        {
          label: "Secretaria Inicial",
          field: "secretaria_old",
        },
        {
          label: "Secretaria Atual",
          field: "secretaria_new",
        },
        {
          label: "Data da Alteração",
          field: "data",
        },
        {
          label: "Horario",
          field: "horario",
          sortable: false,
        },
        {
          label: "IP",
          field: "ip",
        },
        {
          label: "id",
          field: "id",
          hidden: true,
        },
      ],
      log: [],
      listaLogID: null,
      secretaria: [],
      list_usuarios: [],
      user: {
        admin: null,
        admin_sistema: null,
        id: null,
      },
    };
  },
  methods: {
    async exibir(row){
      //console.log(row);
      this.listaLogID = [];
      let data = await this.$listarLogMovManifestacaoID(row.uuid);

      let listarLog = data.data;

      listarLog.forEach(array => {
        let usuario = "";
        let secretariaNew;
        let secretariaOld;

        this.list_usuarios.forEach(element => {
          if(array.usuario_sistema == element.id){
            usuario = element.name;
          }
        });
          
        this.secretaria.forEach(element => {
            if(array.secretaria_new == element.id){
              secretariaNew = element.secretaria;
            }
            if(array.secretaria_old == element.id){
              secretariaOld = element.secretaria;
            }
        });

        let divDateHorario = array.created_at;
        let DateHorario = divDateHorario.split(" ");
      
        // data que foi criada
        let DateDiv = DateHorario[0].split("-"); 
        let DateCompleta = DateDiv[2]+'/'+DateDiv[1]+'/'+DateDiv[0];
        let mes = DateDiv[1];
        let ano = DateDiv[0];
        let dia = DateDiv[2];

        // hora que foi criada
        let horaDiv = DateHorario[1]; 

        let logPerson = {
          id: array.id,
          usuario_sistema: usuario,
          secretaria_old: secretariaOld,
          secretaria_new: secretariaNew,
          ip: array.ip,
          uuid: array.uuid,
          horario: horaDiv,
          data: DateCompleta,
          mes: mes,
          ano: ano,
          dia: dia,
        };

        this.listaLogID.push(logPerson); 
      });

      //this.listaLogID = data.data;

    },
    async listarTudo() {
      try {
        //this.secretarias();
        //this.listaUsuarios();

        let data = await this.$listarLogMovManifestacao();
        let listarLog = data.data.reverse();

        let s = await this.$listarUsuarios();
        let usuarios = s.data;

        let se = await this.$secretaria();
        let secretarias = se.data;

        listarLog.forEach(array => {
          this.filtro(array,usuarios,secretarias);
        });

      } catch (e) {}
    },
    async filtro(array,usuarios,secretarias) {
      try {
        let usuario;
        let secretariaNew;
        let secretariaOld;

        usuarios.forEach(element => {
          if(array.usuario_sistema == element.id){
            usuario = element.name;
          }
        });

        secretarias.forEach(element => {
          if(array.secretaria_new == element.id){
            secretariaNew = element.secretaria;
          }
        });

        secretarias.forEach(element => {
          if(array.secretaria_old == element.id){
            secretariaOld = element.secretaria;
          }
        });

        let divDateHorario = array.created_at;
        let DateHorario = divDateHorario.split(" ");
      
        // data que foi criada
        let DateDiv = DateHorario[0].split("-"); 
        let DateCompleta = DateDiv[2]+'/'+DateDiv[1]+'/'+DateDiv[0];
        let mes = DateDiv[1];
        let ano = DateDiv[0];
        let dia = DateDiv[2];

        // hora que foi criada
        let horaDiv = DateHorario[1]; 

        let logPerson = {
          id: array.id,
          usuario_sistema: usuario,
          secretaria_old: secretariaOld,
          secretaria_new: secretariaNew,
          ip: array.ip,
          uuid: array.uuid,
          horario: horaDiv,
          data: DateCompleta,
          mes: mes,
          ano: ano,
          dia: dia,
        };

        this.log.push(logPerson); 
        

      } catch (error) {
           
      }
    },
    async secretarias(){
      let se = await this.$secretaria();
      this.secretaria = se.data;
    },
    async listaUsuarios(){
      let s = await this.$listarUsuarios();
      this.list_usuarios = s.data;
    }
  },
  beforeMount() {
    try {

      this.listarTudo();
      this.secretarias();
      this.listaUsuarios();
      this.user.admin = store.admin;
      this.user.admin_sistema = store.admin_sistema;
      this.user.id = store.id;
    } catch (e) {}
  },
};
</script>

<style scoped>
.item-log{
  font-weight: 600;
  color: #7d7d7d;
} 

.item-log:hover{
  color: #b5b3b3;
  cursor: pointer;
}

.calendar-sm {
  width: 50px;
  min-width: 50px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  border: 1px solid rgba(62,69,94,.25);
  background: #fff;
  overflow: hidden;
}

.calendar-sm .month {
  /*background: #137df7;*/
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  line-height: 1;
  text-align: center;
  padding: 3px 0;
}
.calendar-sm .cor1{
 background: #FF9800;
}
.calendar-sm .cor2{
  background: #ff00ff;
}
.calendar-sm .cor3{
  background: #eeff00;
}
.calendar-sm .cor4{
  background: #88ff00;
}
.calendar-sm .cor5{
  background: #00ffbf;
}
.calendar-sm .cor6{
  background: #00d9ff;
}
.calendar-sm .cor7{
  background: #008cff;
}
.calendar-sm .cor8{
  background: #003cff;
}
.calendar-sm .cor9{
  background: #8400ff;
}
.calendar-sm .cor10{
  background: #ff00ea;
}
.calendar-sm .cor11{
  background: #137df7;
}
.calendar-sm .cor12{
  background: #ff0037;
}
.calendar-sm .month {
    font-size: .875em;
}

.calendar-sm .day {
    line-height: 1;
    text-align: center;
    padding: 3px 0;
}

.calendar-sm .day {
    font-size: 1.5em;
}

.calendar-sm .day-abbr {
    line-height: 1;
    color: rgba(62,69,94,.75);
    text-align: center;
    padding-bottom: 3px;
}

.cards-default .cards-list .card .calendar-sm+.content-info {
    width: -webkit-calc(100% - 64px);
    width: calc(100% - 64px);
}

.cards-default .cards-list .card .content .title {
  color: #3e455e;
  font-weight: 500;
  line-height: 1.3;
  text-decoration: none;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
  display: block;
}

.cards-list .card .content {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
}
.card-col{
  width: calc(calc(100% / 4) - (16px * 2));margin-left: 10px;
}

@media(max-width:1440px){
  .card-col{
    width: calc(calc(100% / 2) - (16px * 2));
  }
}

@media(max-width:992px){
  .card-col{
    width: calc(calc(100% / 1) - (16px * 2));
  }
}

</style>